import React from 'react';
import { Container, Paper, Typography, Box } from '@mui/material';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';

const PaymentCancelled: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Container maxWidth="sm">
      <LanguageSwitcher />
      <Paper elevation={3} sx={{ p: 4, mt: 4, textAlign: 'center' }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            mb: 2,
          }}
        >
          <CancelOutlinedIcon sx={{ fontSize: 64, color: 'error.main', mb: 1 }} />
          <Typography variant="h4" gutterBottom>
            {t('paymentCancelled.title')}
          </Typography>
        </Box>
        <Typography variant="body1">{t('paymentCancelled.description')}</Typography>
      </Paper>
    </Container>
  );
};

export default PaymentCancelled;
